// extracted by mini-css-extract-plugin
export default {"title":"_7377a8f9b9","bld":"_19a21e9035"};